import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Input, Button, Modal, Table, Icon, Pagination, Message } from 'semantic-ui-react';
import { setActivePage, openHolidayModal, addHoliday, getHolidays, removeHoliday, sortHoliday } from '../actions';
import DatePicker from "react-datepicker";
import props from "prop-types";
import moment from 'moment';
import _ from 'lodash';

// helper function to reorder item


class Holiday extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            holiday_list: [],
            openModal: false,
            description: "",
            date: new Date(),
            new_holiday_error_message: null,
            column: null,
            length: 0,
            direction: null,
            page: 0,
            rowsPerPage: 15,
            searchValue: '',

        }

        this.handleChangeStart = this.handleChangeStart.bind(this);
    }

    componentWillMount() {
        this.props.getHolidays({});

    }

    componentDidMount() {
        this.props.setActivePage('holiday');

    }

    handleChangeStart(date) {

        this.setState({
            date: date

        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.holiday.list !== nextProps.holiday.list) {
            console.log(this.props.holiday.list);
            console.log(nextProps.holiday.list);
            // For Comparing Input Dates and Array Dates
            this.setState({ holiday_list: nextProps.holiday.list });
            // For Table
            this.setState({ data: _.chunk(nextProps.holiday.list, this.state.rowsPerPage), length: nextProps.holiday.list.length, column: nextProps.holiday.sortColumn, direction: nextProps.holiday.sortDirection, page: 0 });

        } else if ((this.props.holiday.sortColumn !== nextProps.holiday.sortColumn) || (this.props.holiday.sortDirection !== nextProps.holiday.sortDirection)) {
            this.setState({ data: _.chunk(nextProps.holiday.list, this.state.rowsPerPage), column: nextProps.holiday.sortColumn, direction: nextProps.holiday.sortDirection });
        }


    }

    //Add Holiday 

    addNewHoliday() {
        const { date, description, holiday_list } = this.state;

        let handleCheckHoliday = (holiday_list, val) => {
            return holiday_list.some(arrVal => {
                //  return val === (moment(arrVal._id).format('DD/MM/YYYY'))\

                return (moment(arrVal._id)).isSame(moment(val).startOf('day'));
            });
        };

        if (!date || !description) {
            this.setState({ new_holiday_error_message: 'Please input all required fields' })


        } else if (handleCheckHoliday(holiday_list, date)) {
            this.setState({ new_holiday_error_message: 'The date already have holiday description' })

        } else {
            let newHoliday = {
                description: description,
                date: date,
            };

            console.log(date);
            console.log(newHoliday);
            this.props.addHoliday(newHoliday);
            this.setState({ new_holiday_error_message: null })
            this.props.getHolidays({});
        }
    }



    handleHolidayModalInput(event) {
        var elementId = event.target.id;
        var elementValue = event.target.value;

        var newState = {};


        newState[elementId] = elementValue;
        this.setState(newState);
    }





    removeHoliday(holiday_id) {
        var isConfirmed = window.confirm(`Delete this holiday (${holiday_id})?`);
        if (isConfirmed === false) {
            return;
        }

        this.props.removeHoliday(holiday_id);
    }

    handleSort = (clickedColumn) => () => {
        this.props.sortHoliday(clickedColumn);
    }

    handleSearchChange = (e) => {
        var sValue = e.target.value;
        this.setState({ searchValue: sValue });
    }

    handleSearchSubmit = (e) => {
        if (e.keyCode !== 13) {
            return;
        }

        const re = new RegExp(_.escapeRegExp(e.target.value), 'i')
        const isMatch = result => (re.test(result.description));

        let day_list = _.filter(this.props.holiday.list, isMatch);
        this.setState({ data: _.chunk(day_list, this.state.rowsPerPage), length: day_list.length });
    }


    render() {

        const { data, page, column, direction, rowsPerPage, length, searchValue } = this.state;



        return (
            <Fragment>

                <div className="ui clearing segment"  >

                    <Form>
                        <Form.Group widths='equal' inline>

                            <Form.Field width={7}>
                                {/* To align center */}
                            </Form.Field>

                            <Form.Field required>
                                <label style={{ fontSize: '14px', marginRight: '20px' }}>Start Date</label>
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={this.state.date}
                                    selectsStart
                                    date={this.state.date}
                                    onChange={this.handleChangeStart}
                                    todayButton={"Click to Today"}
                                    showMonthDropdown
                                    customInput={<DatePickerInput value={props.value} onClick={props.onClick} />}
                                />
                            </Form.Field>

                            <Form.Field required>
                                <label style={{ fontSize: '14px', marginRight: '20px' }}>Description</label>
                                <Input id="description"
                                    value={this.state.description}
                                    onChange={this.handleHolidayModalInput.bind(this)}
                                    placeholder="Description" />
                            </Form.Field>



                            <Form.Field>
                                <Button color='primary' style={{ height: '3em', margin: '20px 0px' }} onClick={this.addNewHoliday.bind(this)} >Create</Button>
                            </Form.Field>
                        </Form.Group>
                    </Form>

                </div>


                {this.state.new_holiday_error_message !== null && (
                    <Message
                        error
                        header='Error'
                        content={this.state.new_holiday_error_message}
                        style={{ display: 'block' }}
                    />
                )}
                <div className="ui clearing segment">

                    <div class="ui icon input">
                        {/* Search Bar */}
                        <input type="text" placeholder="Search..." value={searchValue} onKeyUp={this.handleSearchSubmit} onChange={this.handleSearchChange} />
                        <i aria-hidden="true" className="search icon"></i>
                    </div>


                    <Table sortable striped selectable >
                        <Table.Header>
                            <Table.Row>
                                {/* Show if the code is currently good or expired */}

                                <Table.HeaderCell style={{ width: '20%' }} sorted={column === '_id' ? direction : null} onClick={this.handleSort('_id')}>
                                    Holiday Date
                            </Table.HeaderCell>
                                <Table.HeaderCell style={{ width: '50%' }} sorted={column === 'description' ? direction : null} onClick={this.handleSort('description')}>
                                    Description
                            </Table.HeaderCell>
                                <Table.HeaderCell style={{ width: '10%' }}>
                                    Actions
                            </Table.HeaderCell>
                            </Table.Row>

                        </Table.Header>

                        <Table.Body>
                            {data[page] &&
                                data[page].map((holiday, index) => {
                                    return (
                                        <Table.Row key={index}>
                                            <Table.Cell>{holiday._id ? moment(holiday._id).format('DD/MM/YYYY') : 'NIL'}</Table.Cell>
                                            <Table.Cell>{holiday.description}</Table.Cell>
                                            <Table.Cell>
                                                <Button onClick={this.removeHoliday.bind(this, holiday._id)} >DELETE</Button>
                                            </Table.Cell>
                                        </Table.Row>)
                                })
                            }
                        </Table.Body>
                    </Table>

                    <Pagination style={{ float: 'right' }} defaultActivePage={page + 1} totalPages={Math.ceil(length / rowsPerPage)} onPageChange={(e, data) => this.setState({ page: data.activePage - 1 })} />
                </div>

            </Fragment>
        )
    }
}

const DatePickerInput = ({ value, onClick }) => (
    <Input
        name="requestedDate"
        value={value}
        placeholder="Date"
        onClick={onClick}
        // classNameName="calendar-input"
        style={{ cursor: 'pointer' }}
        autoComplete="false"
        readOnly={true}
    />
);

const mapStateToProps = ({ holiday }) => {
    return { holiday };
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setActivePage: setActivePage,
        openHolidayModal: openHolidayModal,
        addHoliday: addHoliday,
        getHolidays: getHolidays,
        removeHoliday: removeHoliday,
        sortHoliday: sortHoliday,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Holiday);